import './style.scss'

import React, { Component } from 'react'

import RegionDropDown from 'components/RegionDropDown'
import AddressForm from 'components/Forms/AddressForm'
import Button from 'components/UI/Button'
import ButtonRow from 'components/UI/ButtonRow'
import DropDown from 'components/UI/DropDown'
import Icon from 'components/UI/Icon'
import PropTypes from 'prop-types'
import { capitalize } from 'utilities/text'
import classNames from 'classnames'
import { connect } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import marker from 'theme/icons/marker.svg'
import { toggleAddressDropdown } from 'actions/UI'
import { setActiveAddress, storeAddress, toggleEditAddress } from 'actions/Address'
import { withTranslation } from 'react-i18next'
import warning from 'img/warning.svg'

export class AddressDropDown extends Component {
    constructor(props) {
        super(props)
        this.state = {
            edit: false,
        }
    }

    handleSelectAddress(address, close) {
        const { dispatch } = this.props
        dispatch(setActiveAddress(address))
        close && dispatch(toggleAddressDropdown())
    }

    handleStoreAddress(address) {
        this.props.dispatch(storeAddress(address))
    }

    handleClose() {
        if (!this.props.showApartmentNumberHelpModal) {
            this.props.dispatch(toggleAddressDropdown(false))
        }
    }

    handleEditAbort() {
        if (!this.props.noAddresses) {
            this.props.dispatch(toggleEditAddress())
        } else {
            this.props.dispatch(toggleAddressDropdown(false))
        }
    }

    render() {
        const {
            expanded,
            dispatch,
            title,
            loading,
            canDeliver,
            isRegionDropDownShowing,
            noAddresses,
            editAddress,
            t,
        } = this.props

        const classes = classNames({
            'address-dropdown': true,
            'address-dropdown--expanded': expanded,
            'address-dropdown--no-delivery': !canDeliver,
        })
        return (
            <div className={classes}>
                <DropDown
                    title={title}
                    loading={loading}
                    expanded={expanded}
                    scrollable
                    icon={
                        canDeliver ? (
                            <Icon svg={marker} size="medium" />
                        ) : (
                            <Icon className="icon-warning" svg={warning} />
                        )
                    }
                    onClose={() => this.handleClose()}
                    onClick={() => {
                        dispatch(toggleAddressDropdown())
                        if (noAddresses) {
                            dispatch(toggleEditAddress(true))
                        }
                    }}
                >
                    <p className="address-dropdown__description">{t('addressDropDownIntro')}</p>
                    <RegionDropDown />
                    <h3>
                        {isRegionDropDownShowing
                            ? t('addressDropDownDeliveryTitle')
                            : t('addressDropDownDeliveryTitleSingular')}
                    </h3>
                    <AddressForm
                        onSelected={(address, close) => this.handleSelectAddress(address, close)}
                        onStore={(address) => this.handleStoreAddress(address)}
                        onClose={() => dispatch(toggleAddressDropdown(false))}
                        onAbort={() => this.handleEditAbort()}
                    />
                    {!editAddress && (
                        <ButtonRow style="centered">
                            <Button
                                variant="secondary"
                                onClick={() => dispatch(toggleEditAddress(true))}
                            >
                                {t('addressDropDownAdd')}
                            </Button>
                        </ButtonRow>
                    )}
                </DropDown>
            </div>
        )
    }
}

AddressDropDown.propTypes = {
    isRegionDropDownShowing: PropTypes.bool,
    showApartmentNumberHelpModal: PropTypes.bool,
    dispatch: PropTypes.func,
    noAddresses: PropTypes.bool,
    editAddress: PropTypes.bool,
    expanded: PropTypes.bool,
    title: PropTypes.string,
    loading: PropTypes.bool,
    canDeliver: PropTypes.bool,
    hasSavedAddresses: PropTypes.bool,
    t: PropTypes.func,
}

const mapStateToProps = ({ address, distribution, region, ui }) => {
    const isRegionDropDownShowing = region.regions.length > 0

    const activeAddress = address.active
    let title
    if (isEmpty(activeAddress)) {
        title = 'Din addresse'
        if (region.name) {
            title = capitalize(region.name)
        }
    } else {
        title = `${capitalize(activeAddress.streetName)}`
        title += ` ${activeAddress.streetNo}`
        title += `${activeAddress.entrance || ''}`
    }
    return {
        isRegionDropDownShowing,
        editAddress: address.edit,
        noAddresses: address.addresses.length < 1,
        canDeliver: distribution.canDeliver || distribution.distributionLoading,
        title: title,
        expanded: ui.showAddressDropdown,
        showApartmentNumberHelpModal: ui.showApartmentNumberHelpModal,
        loading: address.loading,
    }
}

export default connect(mapStateToProps)(withTranslation()(AddressDropDown))
